<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست دوره ها</h1>
          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <!-- Search -->
              <b-col cols="12" md="5">
                <b-form-group label="انتخاب سطح دوره" label-for="courseType">
                  <v-select
                    id="courseType"
                    dir="rtl"
                    v-if="courseTypes"
                    :reduce="(title) => title.courseTypeId"
                    v-model="courseTypeId"
                    :options="courseTypes"
                    label="title"
                    placeholder="سطح مورد نظر را انتخاب کنید"
                  >
                    <template #no-options
                      >هیچ سطحی جهت نمایش وجود ندارد</template
                    >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="5">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-group
                    class="d-inline-block w-100"
                    label="جستجو کنید"
                    label-for="questionLevel"
                  >
                    <b-form-input
                      v-model="searchCommand"
                      class="d-inline-block"
                      placeholder="جستجو..."
                      @keydown.enter="getAllCourses"
                    />
                  </b-form-group>
                  <b-button
                    variant="primary"
                    class="ml-1"
                    @click="getAllCourses"
                  >
                    اعمال
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="courseList"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(dependency)="data">
              {{
                data.item.dependency && data.item.owner
                  ? data.item.owner.title
                  : "-"
              }}
            </template>
            <template #cell(createDate)="data">
              {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(Edit)="data">
              <b-link :to="`/courses/${data.item.courseId}`">
                <feather-icon class="text-primary" icon="EditIcon" size="20" />
              </b-link>
            </template>
            <template #cell(Delete)="data">
              <div
                style="cursor: pointer"
                @click="renderDeleteConfirmation(data.item.courseId)"
                v-b-modal.modal-delete
              >
                <feather-icon class="text-danger" icon="Trash2Icon" size="20" />
              </div>
            </template>
          </b-table>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
          >
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="count"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
        <b-modal
          title="حذف دوره"
          id="modal-delete"
          centered
          ok-title="بله"
          cancelTitle="خیر"
          @ok="deleteACourse"
        >
          <span>آیا از حذف کردن این دوره اطمینان دارید ؟ </span>
        </b-modal>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { GetAllCourses, DeleteACourse } from "../../../libs/Api/Course";
import { GetCourseTypes } from "../../../libs/Api/CourseType";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { getUserData } from "@/auth/utils";
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
export default {
  mounted() {
    this.getAllCourses();
    this.getAllCourseTypes();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllCourses();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      tempCourseId: null,
      courseList: null,
      pageNumber: 1,
      count: 10,
      totalCount: null,
      searchCommand: null,
      courseTypes: null,
      courseTypeId: null,
      myTableColumns: [
        {
          key: "courseId",
          label: "شناسه دوره",
        },
        {
          key: "title",
          label: "عنوان دوره",
        },
        {
          key: "dependency",
          label: "پیش نیاز",
        },
        {
          key: "createDate",
          label: "تاریخ ثبت",
        },
        {
          key: "Edit",
          label: "ویرایش",
        },
        {
          key: "Delete",
          label: "حذف",
        },
      ],
    };
  },
  methods: {
    async getAllCourseTypes() {
      let _this = this;
      let getCourseTypes = new GetCourseTypes(_this);
      getCourseTypes.setParams({
        count: 10,
        pageNumber: 1,
      });
      await getCourseTypes.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.courseTypes = response.data.courseTypes;
          }
        },
        function (error) {
          console.error(error);
        }
      );
    },
    renderDeleteConfirmation(courseId) {
      this.tempCourseId = courseId;
    },
    async deleteACourse() {
      this.isLoading = true;
      let _this = this;
      try {
        let deleteACourse = new DeleteACourse(_this);
        deleteACourse.setRequestParam({
          id: _this.tempCourseId,
        });
        await deleteACourse.fetch(function (response) {
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: "حذف با موفقیت انجام شد",
              icon: "Trash2Icon",
              variant: "success",
            },
          });
          _this.getAllCourses();
        });
      } catch (error) {
        _this.$toast({
          component: ToastificationContent,
          props: {
            title: "حذف نشد!",
            text: "این دوره دانشجو دارد و قابل حذف کردن نیست",
            icon: "Trash2Icon",
            variant: "danger",
          },
        });
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllCourses() {
      this.isLoading = true;
      let _this = this;
      let getAllCourses = new GetAllCourses(_this);
      let qParams = {
        count: _this.count,
        pageNumber: _this.pageNumber,
      };
      if (this.searchCommand) {
        qParams["searchCommand"] = this.searchCommand;
      }
      if (this.courseTypeId) {
        qParams["courseTypeId"] = this.courseTypeId;
      }
      getAllCourses.setRequestParam(qParams);
      await getAllCourses.fetch(
        function (response) {
          _this.totalCount = response.data.coursesCount;
          _this.courseList = response.data.courses;
        },
        function (error) {
          console.error(error);
        }
      );
      this.isLoading = false;
    },
  },
  computed: {
    userLanguageId() {},
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    BModal,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    vSelect,
  },
};
</script>
